// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout--account{display:flex;flex-direction:column;min-height:var(--app-height)}.layout--account .page{width:100%}.layout--account .crt__body{font-family:\"Open Sans\";font-style:normal;font-weight:700;font-size:14px;line-height:21px;color:var(--clr-text)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
